<template>
  <div class="my-5">
    <v-row class="mx-0 page-header" align="center">
      <span class="px-5 py-2 text-h6 font-weight-regular">
        <slot name='title'></slot>
      </span>
      <v-spacer></v-spacer>
      <slot name='action'></slot>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
    },
  },
  data() {
    return {
      key: null
    }
  },
  methods: {
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
  },
}
</script>

<style>
.page-header{
  background: #fff;
  border: 0.5px solid #eee;
  border-radius: 6px;
  /* padding: 6px 2px 6px 2px;
  -webkit-box-shadow: 0px 0px 8px 1px rgba(0,0,0,0.05);
  -moz-box-shadow: 0px 0px 8px 1px rgba(0,0,0,0.05);
  box-shadow: 0px 0px 8px 1px rgba(0,0,0,0.05); */
}
</style>